import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import elementType from 'prop-types-extra/lib/elementType';
import { noop } from 'lodash/fp';
import cns from 'classnames';
import CheckIcon from 'components/icons/CheckIcon.com.svg';
import { InputBoxesControl } from 'components/forms/InputBoxes';

import mapStateToProps from './mapStateToProps';
import cn from './styles.local.less';

export default class ModalSelect extends PureComponent {
  static propTypes = {
    OptionLabel: elementType.isRequired,
    OptionModalLabel: elementType.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    filterInputProps: PropTypes.object,
    iconNode: PropTypes.node,
    input: PropTypes.object,
    inputNode: PropTypes.node,
    isGroup: PropTypes.bool,
    isPlaceholder: PropTypes.bool,
    labelNode: PropTypes.node,
    modalTitle: PropTypes.string,
    onSelect: PropTypes.func,
    options: PropTypes.array,
    searchable: PropTypes.bool,
    selectedOption: PropTypes.object.isRequired,
    type: PropTypes.string,
    value: PropTypes.any,
  };

  static defaultProps = {
    filterInputProps: {},
    onSelect: noop,
    options: [],
  };

  state = {
    filterInputValue: '',
    isModalOpen: false,
  };

  focus = noop;

  closeModal = () => {
    this.setState({
      filterInputValue: '',
      isModalOpen: false,
    });
  };

  handleMobileSelectClick = () => {
    const { disabled } = this.props;

    if (!disabled) {
      this.setState({
        isModalOpen: true,
      });
    }
  };

  handleModalInput = (e) => {
    this.setState({
      filterInputValue: e.target.value,
    });
  };

  handleChangeSelect = (value) => {
    const { onSelect } = this.props;

    this.closeModal();

    onSelect(value);
  };

  renderBox = (props) => {
    const {
      className,
      iconNode,
      input,
      inputNode,
      isGroup,
      isPlaceholder,
      labelNode,
      value,
    } = props;
    const { OptionModalLabel } = this.props;
    const { isGroupedOptions } = mapStateToProps(this.state, this.props);

    if (isGroup && !value) {
      return <div className={cn.boxTitle}>{labelNode}</div>;
    }

    return (
      <label
        className={cns(cn.box, {
          [cn.childrenBox]: !isGroup && !isPlaceholder && isGroupedOptions,
        })}
      >
        {inputNode}
        <div className={cns(cn.label)}>
          <OptionModalLabel
            {...props}
            className={cns(className, {
              [cn.checked]: input.checked,
              [cn.bold]: isGroup && !isPlaceholder && isGroupedOptions,
            })}
          />
        </div>
        {iconNode}
      </label>
    );
  };

  renderIcon({ input }) {
    return input.checked ? <CheckIcon className={cn.checkIcon} /> : null;
  }

  render() {
    const maxTitleLength = 25;
    const { options, modalTitle } = mapStateToProps(this.state, this.props);
    const { filterInputValue, isModalOpen } = this.state;
    const { OptionLabel, filterInputProps, searchable, selectedOption } =
      this.props;

    return (
      <div className={cns(cn.root, 'form-control', 'select__modal-select')}>
        <div
          className={cns(cn.labelWrapper, 'select__modal-select-labelWrapper')}
          onClick={this.handleMobileSelectClick}
        >
          <OptionLabel
            {...selectedOption}
            className={cns(cn.selectedLabel, 'select__modal-selected-label')}
          />
        </div>
        <Modal
          animation={false}
          backdropClassName={cns(cn.backdrop)}
          className={cns(cn.fadeIn, cn.modal)}
          keyboard
          onHide={this.closeModal}
          show={isModalOpen}
        >
          <Modal.Header closeButton>
            {modalTitle ? (
              <Modal.Title
                componentClass={
                  modalTitle.length > maxTitleLength ? 'h3' : 'h2'
                }
              >
                {modalTitle}
              </Modal.Title>
            ) : null}
            {searchable ? (
              <input
                placeholder={__('selectFilter.placeholder')}
                type="text"
                {...filterInputProps}
                className={cns(
                  cn.input,
                  'form-control',
                  filterInputProps.className,
                )}
                onInput={this.handleModalInput}
                value={filterInputValue}
              />
            ) : null}
          </Modal.Header>
          <Modal.Body>
            <InputBoxesControl
              Container="div"
              Box={this.renderBox}
              Icon={this.renderIcon}
              options={options}
              input={{
                value: selectedOption.value,
                onChange: this.handleChangeSelect,
              }}
              type="radio"
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
